function cov_17iagboeay() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BathroomFilled.tsx";
  var hash = "fe833dbb13991ab3c9626e58ee99e90799604219";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BathroomFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fe833dbb13991ab3c9626e58ee99e90799604219"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17iagboeay = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17iagboeay();
var Icon = (cov_17iagboeay().s[0]++, {
  name: 'bathroom-filled',
  svg: "<path d=\"M4.05947 2C2.92206 2 2 2.92205 2 4.05947V11.341C2 12.7852 2.73336 14.1305 3.94713 14.913L6.98864 16.8739C7.6962 17.33 7.9787 18.2253 7.66106 19.005L6.23712 22.5H17.2385V19.3444C20.2661 18.8755 22.5 16.2693 22.5 13.2052C22.5 12.3237 21.7854 11.609 20.9038 11.609H11.5154V9.45592C11.5154 5.33813 8.17726 2 4.05947 2Z\" fill=\"currentColor\"/>"
});
export default Icon;